export default __webpack_public_path__ + "static/media/95.66785718.jpeg";